import { type PaginatedResponse } from "@/shared/http";

import { type FilterOptionsResolver } from "./FilterDefinition";

/**
 * Adapt a paginated string search into a {@link FilterOptionsResolver}.
 */
export function toOptionsResolver(
  search: (
    term: string,
    signal?: AbortSignal,
  ) => Promise<PaginatedResponse<string>>,
): FilterOptionsResolver {
  return async (term, signal) => {
    const page = await search(term, signal);
    return { options: page.items, truncated: page.next_token !== null };
  };
}
